import { render, staticRenderFns } from "./CabinetBlankTemplate.vue?vue&type=template&id=0bdf1782"
import script from "./CabinetBlankTemplate.vue?vue&type=script&lang=ts"
export * from "./CabinetBlankTemplate.vue?vue&type=script&lang=ts"
import style0 from "./CabinetBlankTemplate.vue?vue&type=style&index=0&id=0bdf1782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports